import React, { useRef, useState, useCallback } from "react";
import EditIcon from "@material-ui/icons/Edit";
import CircularProgress from "@material-ui/core/CircularProgress";
import Skeleton from "@material-ui/lab/Skeleton";
import { httpPost } from "../../../../../Utils/apis/apis";
import { useParams } from "react-router";
import { connect } from "react-redux";
import * as toastActions from "../../../../../store/actions/toastActions";
import PropTypes from "prop-types";
import { toastSeverity } from "../../../../../Utils/config/toastConfig";
import { message } from "../../../../../Utils/config/messages";
import "./A_ProfilePic.css";

const A_ProfilePicture = ({ src, alt, isReadOnly, callback, loading, setToast }) => {
  const inputFile = useRef(null);
  const { crmId } = useParams();

  const [imageLoaded, setImageLoaded] = useState(false);
  const [uploading, setUploading] = useState(false);

  const isBusy = loading || uploading;

  const uploadImage = useCallback(
    async (e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        return setToast({
          type: toastSeverity.ERROR,
          severity: toastSeverity.ERROR,
          message: "Invalid image file",
          status: true,
        });
      }

      const formData = new FormData();
      formData.append("file", file);

      setUploading(true);

      try {
        const res = await httpPost(
          `/SecureImageBlob/uploadResizedImageBlob?crmId=${crmId}`,
          formData,
          {},
          true
        );

        if (res.status === 200) {
          callback?.();
          setToast({
            type: toastSeverity.SUCCESS,
            severity: toastSeverity.SUCCESS,
            message: "Profile photo updated",
            status: true,
          });
        } else throw new Error();
      } catch {
        setToast({
          type: toastSeverity.ERROR,
          severity: toastSeverity.ERROR,
          message: message.SOMETHING_WENT_WRONG,
          status: true,
        });
      } finally {
        setUploading(false);
      }
    },
    [crmId, callback, setToast]
  );

  return (
    <div className="profile-container">

      {/* Show skeleton until actual image loads OR parent loading */}
      {!imageLoaded || loading ? (
        <Skeleton variant="rect" width={90} height={90} animation="wave" />
      ) : null}

      <img
        src={src}
        alt={alt}
        className={`profile-img ${!imageLoaded || loading ? "hidden-img" : "visible-img"}`}
        onLoad={() => setImageLoaded(true)}
      />

      {/* Uploading overlay */}
      {uploading && (
        <div className="upload-overlay">
          <CircularProgress size={32} />
        </div>
      )}

      {/* Edit button (only when not busy and not read only) */}
      {!isReadOnly && !isBusy && (
        <div className="edit-btn" onClick={() => inputFile.current.click()}>
          <EditIcon fontSize="small" />
        </div>
      )}

      <input
        type="file"
        accept="image/*"
        hidden
        ref={inputFile}
        onChange={uploadImage}
      />
    </div>
  );
};

A_ProfilePicture.defaultProps = {
  src: "",
  alt: "Profile",
  loading: false,
};

A_ProfilePicture.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  isReadOnly: PropTypes.bool,
  callback: PropTypes.func,
  loading: PropTypes.bool,
  setToast: PropTypes.func.isRequired,
};

export default connect(null, toastActions)(A_ProfilePicture);
